import script from "./Generate.vue?vue&type=script&setup=true&lang=ts"
export * from "./Generate.vue?vue&type=script&setup=true&lang=ts"

import "./Generate.scss?vue&type=style&index=0&id=3b009530&scoped=true&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3b009530"]])

export default __exports__